import type { GenerationJobRow } from "@/types/workspace"

export function terminalToastKind(job: Pick<GenerationJobRow, "job_kind" | "canvas_generation_id">): string {
  if (job.job_kind === "sketch_edit" && job.canvas_generation_id != null && job.canvas_generation_id > 0) {
    return "canvas_generate"
  }

  return job.job_kind
}

export function shouldSkipTerminalToast(
  job: Pick<GenerationJobRow, "job_kind" | "canvas_generation_id">,
  opts: { hasSketchWaiter: boolean },
): boolean {
  if (job.job_kind !== "sketch_edit") return false
  return opts.hasSketchWaiter
}
